export default __webpack_public_path__ + "static/js-604c2462195fce82293fe81225c28cce.webp";